/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Side_CrmInputs */

const cs_pm_side_crm = /** @type {(inputs: Pm_Side_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM`)
};

const en_pm_side_crm = /** @type {(inputs: Pm_Side_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM`)
};

/**
* | output |
* | --- |
* | "CRM" |
*
* @param {Pm_Side_CrmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_side_crm = /** @type {((inputs?: Pm_Side_CrmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Side_CrmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_side_crm(inputs)
	return cs_pm_side_crm(inputs)
});